import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/logins',
    method: 'post',
    data
  })
}


export function getTable(data) {
  return request({
    url: '/jobs/getTable',
    method: 'get',
    data
  })
}


export function getInfo(token) {
  return request({
    url: '/info',
    method: 'get',
    params: { token }
  })
}

export function logout() {
  return request({
    url: '/logout',
    method: 'get'
  })
}
